const ALLOWED_ROLE_KEYS = ['owner', 'admin', 'superadmin'];
const ALLOWED_EMAILS = [
  'mifta.belleandkate@gmail.com',
  'admin.admin@belleandkate.com',
];

function normalizeRole(value) {
  return String(value || '').trim().toLowerCase().replace(/[\s_-]/g, '');
}

function normalizeEmail(value) {
  return String(value || '').trim().toLowerCase();
}

export function canAccessAuditLogQc(admin = window.__currentAdmin) {
  const roleKey = normalizeRole(admin?.role);
  const email = normalizeEmail(admin?.email);
  return ALLOWED_ROLE_KEYS.includes(roleKey) || ALLOWED_EMAILS.includes(email);
}

export default canAccessAuditLogQc;